import React from 'react';

import { ModalBody } from '@atlaskit/modal-dialog';
import { FireScreenAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { IssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import { useIssues } from '../../services/issues/index.tsx';
import DeploymentSummary from './deployment-summary/index.tsx';
import IssueTable from './issue-table/index.tsx';
import NoPermissionForAnyIssues from './no-permission/index.tsx';

type Props = {
	issueIds: IssueId[];
	hasPermissionForAllIssues: boolean;
	deploymentDisplayName: string;
	deploymentUrl: string;
};

const Body = ({
	issueIds,
	deploymentDisplayName,
	deploymentUrl,
	hasPermissionForAllIssues,
}: Props) => {
	const { loading, error, data: issues } = useIssues(issueIds);

	if (!loading && issues === undefined) {
		throw error ?? Error('Unknown error');
	}
	if (issueIds.length === 0 && !hasPermissionForAllIssues) {
		return <NoPermissionForAnyIssues />;
	}
	return (
		<ModalBody>
			<DeploymentSummary
				issueCount={issueIds.length}
				deploymentDisplayName={deploymentDisplayName}
				deploymentUrl={deploymentUrl}
				hasPermissionForAllIssues={hasPermissionForAllIssues}
			/>
			<IssueTable issues={issues ?? 'loading'} />
			<FireScreenAnalytics attributes={{ noPermissionForAnyIssues: false }} />
		</ModalBody>
	);
};

export default Body;
